import React from 'react'
import settingsMainSlider from '../../../images/settings_mainslider.png'
import settingsSlider from '../../../images/settings_slider.png'
import posterCenterSlider from '../../../images/poster_center_slider.png'
import posterRightSlider from '../../../images/poster_right_slider.png'
import classicSlider from '../../../images/classic_slider.png'


const UpdateItem18Jul2023 = ({date, lastUpdate, onClick, activeUpdateText, id}) => {
    const additionalClass = lastUpdate ? 'update-text-open' : activeUpdateText === id ? 'update-text-open' : 'update-text-close' 
    return (
        <div className={"" + additionalClass}>
            {onClick ? (<p onClick={()=>onClick(additionalClass, id)} className="update-title cursor-pointer title-large-color gap-10">{date}</p>)
            :
            (<p className="title-large-color gap-10">{date}</p>)}
            <div className="update-text-content">
                <p className="text-regular-color text-regular-uppercase">
                    NEUES FEATURE / NEW FEATURE
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                        Unser großes Update ist da!<br/>
                        Neue Funktionen, Erweiterungen einiger alten Funktionen und mehr gibt es zu entdecken.
                        <br/><br/>
                        <span className='grey'>Our big update is here!<br/>
                        New features, enhancements to some old functions and more to discover.</span>
                    </p>
                    <br/><br/>
                    <p className="text-regular orange uppercase gap-10">
                        UNSER HIGHLIGHT: VERSCHIEDENE STYLINGMÖGLICHKEITEN DES HAUPSLIDERS, DER SLIDER UND DER HIGHLIGHTS<br/>
                        <span className='grey'>OUR HIGHLIGHT: DIFFERENT STYLING OPTIONS OF THE MAIN SLIDER, THE SLIDERS AND THE HIGHLIGHTS</span>
                    </p>
                    <p className="text-regular gap-10">
                        Die neuen Einstellungen können vorgenommen werden, indem man links neben dem Elementnamen auf den Stift klickt. Es sollte sich ein Popup öffnen, in dem die Überschrift und die Hintergrundbild-Einstellung bearbeitbar sind.<br/>
                        <span className='grey'>You can access the settings by clicking on the pencil to the left of the element name. A popup should open where you can set the headline and the background image.</span>
                    </p>
                    <div>
                        <p className="text-regular gap-10">
                            Einstellungsmöglichkeiten des Hauptsliders<br/>
                            Neben der klassischen Version gibt es jetzt zusätzlich die Auswahl zwischen den folgenden Varianten:<br/>
                            <span className='grey'>Setting options of the main slider<br/>
                            In addition to the classic version, there is now additionally the choice between the following variants:</span>
                        </p>
                        <img width="400px" src={settingsMainSlider}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Für Slider und Highlights besteht die Möglichkeit, den Ken-Burns-Effekt (Animation des Hintergrund-Bildes) zu aktivieren:<br/>
                            <span className='grey'>For sliders and highlights there is the possibility to activate the Ken-Burns effect (Background-Animation):</span>
                        </p>
                        <img width="400px" src={settingsSlider}/>
                    </div>
                    <br/><br/>
                    <p className="text-regular uppercase orange gap-10">
                        Ergebnis in der Website<br/>
                        <span className='grey'>Result in the website</span>
                    </p>
                    <div>
                        <p className="text-regular gap-10">
                            Classic und Ken-Burns-Effekt<br/>
                            Beim Ken-Burns-Effekt zoomt das Bild langsam rein.<br/>
                            <span className='grey'>Classic and Ken-Burns effect<br/>
                            With the Ken-Burns effect, the image zooms in slowly.</span>
                        </p>
                        <img width="550px" src={classicSlider}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Poster rechts angeordnet<br/>
                            Wahl zwischen mit oder ohne Ken-Burns-Effekt.
                            <br/>
                            <span className='grey'>Poster arranged on the right<br/>
                            Choice of with or without Ken Burns effect.</span>
                        </p>
                        <img width="550px" src={posterRightSlider}/>
                    </div>
                    <br/><br/>
                    <div>
                        <p className="text-regular gap-10">
                            Poster mittig angeordnet<br/>
                            Auch hier jeweils mit oder ohne Ken-Burns-Effekt. Zusätzlich wurde auf den Filmtitel verzichtet.<br/>
                            <span className='grey'>Poster centered<br/>
                            Also here in each case with or without Ken Burns effect. In addition, the film title was omitted.</span>
                        </p>
                        <img width="550px" src={posterCenterSlider}/>
                    </div>
                    <br/><br/>
                    <p className="text-regular gap-10">
                        Ein großes neues Feature ist die Filmbearbeitungs-Seite "Filme". Man findet sie unter dem Menüpunkt "Webseite". Hier erhält man einen schnellen Überblick über alle Filme und die fehlenden Inhalte.<br/>
                        <span className='grey'>A great new feature is the movie editing page "Movies". You can find it under the menu item "Website". Here you get a quick overview of all movies and the missing content.</span>
                    </p>
                    <p className="text-regular gap-10">
                        Es ist jetzt möglich, eine TikTok-Verlinkung im Footer neben Instgram und Facebook anzuzeigen.<br/>
                        <span className='grey'>It is now possible to display a TikTok link in the footer next to Instgram and Facebook.</span>
                    </p>
                    <p className="text-regular gap-10">
                        Die Spielzeiten in der Übersicht der Filme sind jetzt verlinkt. So kann man super einfach einzelne Vorstellung über einen eigenen Content oder externe Seiten/Social Media verlinken.<br/>
                        <span className='grey'>The showtimes in the overview of the movies are now linked. This makes it super easy to link individual performances via your own content or external pages/social media.</span>
                    </p>
                </div>

                <p className="text-regular-color text-regular-uppercase">
                    BUGFIX
                </p>
                <div className='gap-35'>
                    <p className="text-regular gap-10">
                        Die Buttons des Cookiebanners sind nun alle identisch in ihrer Farbe. Schönheitsfehler wurden ausgebessert.<br/>
                        <span className='grey'>Cookiebanner buttons are now all identical in color. Blemishes have been fixed.</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default UpdateItem18Jul2023
